module.exports = __webpack_public_path__ + "static/media/smiley-13.53965087.svg";